import propTypes from 'prop-types';
import React from 'react';

import { CloseOutlined } from 'opencare-crown';

import { MobileCloseButton, StyledModal } from './styled-components';

export const OpencareModal = ({
  children,
  centered,
  onClose,
  isOpen,
  showCloseButton,
  maskClosable,
  width,
  padding,
}) => (
  <StyledModal
    centered={centered}
    onCancel={onClose}
    footer={null}
    visible={isOpen}
    maskClosable={maskClosable ?? true}
    closable={showCloseButton}
    destroyOnClose
    width={width}
    padding={padding}
  >
    {showCloseButton
      && (
        <MobileCloseButton type="button" onClick={onClose}>
          <CloseOutlined />
        </MobileCloseButton>
      )}
    {children}
  </StyledModal>
);

OpencareModal.defaultProps = {
  showCloseButton: true,
};

OpencareModal.propTypes = {
  children: propTypes.node,
  centered: propTypes.bool,
  onClose: propTypes.func,
  isOpen: propTypes.bool,
  showCloseButton: propTypes.bool,
  maskClosable: propTypes.bool,
  width: propTypes.string,
  padding: propTypes.shape({
    mobile: propTypes.string,
    desktop: propTypes.string,
  }),
};
